module.exports = __webpack_public_path__ + "img/ahu.da2ab10c.jpg";